import React, { useRef, useState } from 'react'
import emailjs from '@emailjs/browser';
import "../../Css/style.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faMobile, faPhone } from '@fortawesome/free-solid-svg-icons'
import { faInstagram,faFacebook, faLinkedin, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function Contact2() {
  const [userName, setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [message, setMessage] = useState('');
  const [phone, setPhone] = useState('')



  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_l73v5t9', 'template_hl3k92f', form.current, 'gLvNgWY6cSG3J64kE')
      .then((response) => {
        console.log('Email sent successfully:', response);

        // Clear the input fields
        setUserName('');
        setUserEmail('');
        setMessage('');
        setPhone('')

        // Show a success notification
        toast.success('Form submitted successfully', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      })
      .catch((error) => {
        console.error('Error sending email:', error);

        // Show an error notification
        toast.error('An error occurred while submitting the form. Please try again later.', {
          position: 'top-right',
          autoClose: 3000, // 3 seconds
        });
      });
  };
  return (
    <>

      <div className="contact-form-container">
        <img src="./assets/images/newsletter5.png" alt="" className="newsletter-img" />
        <div className="contact-form-content">
          <h1>Contact us</h1>
          <p className="fontP">
            For any query or assistance regarding our services, fill out this form, and we will contact you within 24 hours.
          </p>
          <form ref={form} onSubmit={sendEmail}>
            <input
              type="text"
              name="user_name"
              placeholder="Your good name please"
              value={userName}
              onChange={(e) => setUserName(e.target.value)} required
            />
            <input
              type="email"
              name="user_email"
              placeholder="Your email address"
              value={userEmail}
              onChange={(e) => setUserEmail(e.target.value)} required
            />
            <input
              type="number"
              name="user_phone"
              placeholder="Your Contact number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)} required
            />
            <textarea className='textheight'
              type="text"
              name="message"
              placeholder="Enter your message"
              value={message}
              onChange={(e) => setMessage(e.target.value)} required
              style={{ height: '200px' }} 
            />
            <button type="submit" className="btn btn-primary m-1">
              Submit
            </button>
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
            {/* Same as */}
            <ToastContainer />
          </form>
        </div>
      </div>


      <div className="contact-info-container">
        <div className="txt_center">
          <h3 className='contact-text'>Get in touch with us</h3>
          <div className="box">
            <h4 className="margin">Email <FontAwesomeIcon icon={faEnvelope} size="xl" /></h4>
            <a className="size" href="mailto:contact@upsys.in">contact@upsys.in </a>
          </div>

          <h3 className='contact-text'>Connect with us</h3>
          <div className="box">
            <a href="https://www.facebook.com/profile.php?id=100094900818238&mibextid=ZbWKwL"><FontAwesomeIcon icon={faFacebook} size="xl" /></a>
            <a href="http://wa.me/+918871091864"><FontAwesomeIcon icon={faWhatsapp} size="xl" /></a>
            <a className="marginA1" href="https://www.instagram.com/upsys.in/"><FontAwesomeIcon icon={faInstagram} size="xl" /></a>
            <a className="marginA1" href="https://www.linkedin.com/company/upsys-it-and-marketing-solutions/"><FontAwesomeIcon icon={faLinkedin} size="2xl" /></a>
            <a href="tel:+91 8871091864" className="marginA1 fontIcon"><FontAwesomeIcon icon={faPhone} size="xl" /> </a>
          </div>
        </div>
      </div>
    </>
  )
}

export default Contact2